<app-page-dialog>
    <div dialogTitle class="d-flex" style="gap: 16px;">
        <div class="icon-circle d-flex align-items-center  justify-content-center ">
            <mat-icon style="margin-bottom: 5px; color: #EA7D1D;">warning</mat-icon>
        </div>
        
        <div *ngIf="data.code == 502 || data.code == 666">La teva sessió ha caducat</div>
        <div *ngIf="data.code == 504 ">Sobrecàrrega del servidor</div>
        <div *ngIf="data.code == 667">Canvi d'entitat no permès</div>
    </div>

    <div dialogHeader class="eac-c1" style="padding-left: 64px; position: relative; top: -24px;">
        <ng-container *ngIf="data.code == 502|| data.code == 666">Per raons de seguretat, la teva sessió ha expirat. Si us plau, inicia sessió novament per a continuar utilitzant l'aplicació.</ng-container>
        <ng-container *ngIf="data.code == 504 ">En aquest moment, experimentem una alta demanda d'usuaris, la qual cosa ha portat a una sobrecàrrega del servidor. Et demanem disculpes per les molèsties. Si us plau, reinicia la teva sessió per a millorar l'estabilitat i continuar utilitzant l'aplicació.</ng-container>
        <ng-container *ngIf="data.code == 667">Has seleccionat una entitat diferent en una altra pestanya, la qual cosa no és possible a causa de restriccions de la plataforma. Si us plau, tanca una de les pestanyes i reinicia sessió seleccionant l'entitat desitjada.</ng-container>
    </div>
    <div dialogFooter class="d-flex" style="padding-top: 24px;">
        <div style="flex: 1 0 0;"></div>
        <button mat-flat-button color="primary" (click)="reload()">
            Reiniciar sessió
        </button>
    </div>

</app-page-dialog>

